import { ContentServiceFlowStatus } from './types'
import { Box } from '@mui/material'
import { SmallItalicText } from '../utility/Containers'
import React from 'react'
import { TimeAgo } from 'shared/ui'

export function StatusDetails({
  flowStatus,
}: {
  flowStatus: ContentServiceFlowStatus
}) {
  return (
    <Box>
      <SmallItalicText>
        Created <TimeAgo date={flowStatus.data.details.create_time} />
      </SmallItalicText>
      <SmallItalicText>
        Jobs Completed {flowStatus.meta.completedJobs}/
        {flowStatus.meta.totalJobs}
      </SmallItalicText>
      <SmallItalicText
        color={flowStatus.meta.failedJobs > 0 ? 'error' : 'text.secondary'}
      >
        Jobs Failed {flowStatus.meta.failedJobs}
      </SmallItalicText>
    </Box>
  )
}
